import React, { FC, useEffect, useRef, useState } from 'react';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import QuestionBox from 'src/components/molecules/content/QuestionBox';

interface Props {
  viewType?: string;
}

const Spouse: FC<Props> = ({ viewType }) => {
  const queSet = {
    question: [
      {
        idx: 0,
        status: 'this',
        confirm: '',
        set: {
          question: '과세기간 종료일 현재 배우자가 있나요?',
          style: { width: '300px' },
          desc: {
            style: {},
            data: [
              { text: <div className="_text">혼인신고한 경우만 공제대상자임</div> },
              {
                text: (
                  <div className="_text">
                    연도중 사망시 <em>'네'</em> 선택
                  </div>
                ),
              },
              {
                text: (
                  <div className="_text">
                    연도중 이혼시 <em>'아니오'</em> 선택
                  </div>
                ),
              },
            ],
          },
        },
      },
      {
        idx: 1,
        status: 'ready',
        set: {
          question: '배우자 소득이 있나요?',
          style: { width: '300px' },
          desc: [],
        },
      },
      {
        idx: 2,
        status: 'ready',
        confirm: '',
        set: {
          question: '배우자가 2025년에 근로소득만 있나요?',
          style: { width: '450px' },
          desc: {
            data: [
              {
                text: (
                  <div className="_text">
                    근로소득 외 다른 소득이 있는 경우에는 <em>'아니오'</em>를 선택하세요
                  </div>
                ),
              },
            ],
          },
        },
      },
      {
        idx: 3,
        status: 'ready',
        confirm: '',
        set: {
          question: '배우자의 총급여액은 500만원 이하인가요?',
          style: { width: '400px' },
          desc: [],
        },
      },
    ],
    answer: {
      status: 'ready',
      set: {
        title: '배우자 기본공제를 받을 수 있습니다.',
        status: 'yes',
        desc: {
          data: [
            {
              text: (
                <div className="_text">이때, 총 급여액은 비과세 소득을 제외한 금액을 말합니다.</div>
              ),
            },
          ],
        },
      },
    },
  };

  const [queState, setQueState] = useState({ set: queSet.question });
  const [awsState, setAwsState] = useState({ set: queSet.answer });

  useEffect(() => {
    const queEndStatus = queState.set.filter((item: any) => item.status !== 'end');
    const queConfirmStatus = queState.set.filter((item: any) => item.confirm === 'yes');

    if (queEndStatus.length === 0) {
      awsState.set.status = 'end';
      if (queState.set.length !== queConfirmStatus.length) {
        awsState.set.set.title = '배우자 기본공제를 받을 수 없습니다.';
        awsState.set.set.status = 'no';
      } else {
        awsState.set.set.title = '배우자 기본공제를 받을 수 있습니다.';
        awsState.set.set.status = 'yes';
      }

      setAwsState({ set: awsState.set });
    } else {
      awsState.set.status = 'ready';
      setAwsState({ set: awsState.set });
    }
  }, [queState]);

  return (
    <div className="_spouse_question_div">
      <QuestionBox
        queSet={queSet}
        queState={queState}
        setQueState={setQueState}
        awsState={awsState}
        setAwsState={setAwsState}
      />
    </div>
  );
};

export default Spouse;
